module.exports = __webpack_public_path__ + "tv.svg?9cc2fe565ae3d5a354e6d8cbb17f1902";